import type { TabKind } from './appWorkspaceStore'

export interface ParsedTabPath {
  kind: TabKind
  objectName?: string
  recordId?: string | null
  reportId?: string
  formName?: string
  /** Print tabs only: the in-memory session holding the filled model. */
  sessionId?: string
}

/**
 * Parse a workspace tab path (pathname + optional search) into body props.
 * Returns null when the path is not a recognised data screen.
 */
export function parseTabPath(path: string): ParsedTabPath | null {
  const qIdx = path.indexOf('?')
  const pathname = qIdx >= 0 ? path.slice(0, qIdx) : path
  const search = qIdx >= 0 ? path.slice(qIdx) : ''
  const formName = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search).get('form') || undefined

  if (pathname === '/administration/mail') {
    return { kind: 'mail' }
  }

  // `/print` (no id) stays the standalone deep-link page, not a workspace tab.
  const printMatch = pathname.match(/^\/print\/([^/]+)$/)
  if (printMatch) {
    return { kind: 'print', sessionId: decodeURIComponent(printMatch[1]) }
  }

  const reportMatch = pathname.match(/^\/reports\/([^/]+)$/)
  if (reportMatch) {
    return { kind: 'report', reportId: decodeURIComponent(reportMatch[1]), formName }
  }

  const recordMatch = pathname.match(/^\/app\/([^/]+)\/([^/]+)$/)
  if (recordMatch) {
    const objectName = decodeURIComponent(recordMatch[1])
    const rawId = decodeURIComponent(recordMatch[2])
    return {
      kind: 'record',
      objectName,
      recordId: rawId === 'new' ? null : rawId,
      formName,
    }
  }

  const listMatch = pathname.match(/^\/app\/([^/]+)$/)
  if (listMatch) {
    return {
      kind: 'list',
      objectName: decodeURIComponent(listMatch[1]),
      formName,
    }
  }

  return null
}
